import { render, staticRenderFns } from "./ContractTemplateSettings.vue?vue&type=template&id=0bcee630&scoped=true"
import script from "./ContractTemplateSettings.vue?vue&type=script&lang=js"
export * from "./ContractTemplateSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bcee630",
  null
  
)

export default component.exports